module.exports = __webpack_public_path__ + "static/media/rocket-white.883541f5.png";